import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { dateFormat } from 'formatters/date';
import { IUser, userRolesNames } from 'interfaces/user';
import * as React from 'react';

interface IProps {
  user: IUser;
}

const useStyles = makeStyles(theme => ({
  row: {
    height: theme.spacing(6)
  }
}));

export default function ListItem(props: IProps) {
  const { user } = props;
  const classes = useStyles();

  const formatDate = (user: IUser) => {
    const d = new Date(user.lastAccessDate);
    d.setTime(d.getTime() + (d.getTimezoneOffset() * -1) * 60 * 1000);
    return dateFormat(d, 'dd/MM/yyyy - HH:mm');
  };

  return (
    <TableRow className={classes.row}>
      <TableCell>{user.fullName}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.roles.map(role => userRolesNames[role]).join(', ')}</TableCell>
      <TableCell>
        {user.lastAccessDate ? formatDate(user) : '-'}
      </TableCell>
    </TableRow>
  );
}